import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import classnames from "classnames";

// core components
import Navbar from "../layouts/Navbar.js";

import '../../assets/css/Login.css'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faMobileScreen } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function Register() {

  const navigate = useNavigate();

  const [squares1to6, setSquares1to6] = useState("");
  const [squares7and8, setSquares7and8] = useState("");

  const [fullNameFocus, setFullNameFocus] = useState(false);
  const [cellPhoneFocus, setCellPhoneFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [passwordFocus, setPasswordFocus] = useState(false);

  const [passwordErrors, setPasswordErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState({});

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    passwordCheck: '',
    name: '',
    cellphone: '',
    role: 'user'
  });

  // 전화번호 입력 시에 000-0000-0000과 같은 형태로 표기
  const formatPhoneNumber = (value) => {
    const number = value.trim().replace(/[^0-9]/g, "");

    if (number.length < 4) return number;
    if (number.length < 7) return number.replace(/(\d{3})(\d{1})/, "$1-$2");
    if (number.length < 11) return number.replace(/(\d{3})(\d{3})(\d{1})/, "$1-$2-$3");
    return number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // 입력되는 값이 전화번호 일 때
    if (name ==='cellphone'){
      const number = formatPhoneNumber(value);
      setFormData({"cellphone": number});
    }
  };

  //암호를 두 번 입력하여 검증
  const validatePassword = () => {
    const passwordCheckInputIcon = document.getElementById('passwordCheckIcon');
    const passwordCheckInputBorder = document.getElementById('passwordCheckBorder');

    // "password"와 "passwordCheck" 필드에 대한 유효성 검사를 수행합니다.
    if (formData.password !== formData.passwordCheck) {
      // 비밀번호 확인이 일치하지 않으면 에러 메시지를 설정합니다.
      setPasswordErrors({ passwordCheck: '비밀번호가 일치하지 않습니다.' });

      passwordCheckInputIcon.classList.add('checkIconError');
      passwordCheckInputIcon.classList.remove('checkIconNone');
      passwordCheckInputIcon.classList.remove('checkIconOK');

      passwordCheckInputBorder.classList.add('input-error');
      passwordCheckInputBorder.classList.remove('input-green');

    } else {
      // 비밀번호 확인이 일치하면 에러 메시지를 제거합니다.
      setPasswordErrors({ ...passwordErrors, passwordCheck: '' });
      setPasswordFocus(false);
      
      //공백일 때
      passwordCheckInputIcon.classList.add('checkIconNone');
      passwordCheckInputIcon.classList.remove('checkIconError');
      passwordCheckInputIcon.classList.remove('checkIconOK');

      passwordCheckInputBorder.classList.remove('input-green');
      passwordCheckInputBorder.classList.remove('input-error');
      
      if (formData.password !== '' && formData.passwordCheck !== '' && formData.password !== undefined && formData.passwordCheck !== undefined) {
        passwordCheckInputIcon.classList.add('checkIconOK');
        passwordCheckInputIcon.classList.remove('checkIconError');
        passwordCheckInputIcon.classList.remove('checkIconNone');

        passwordCheckInputBorder.classList.add('input-green');
        passwordCheckInputBorder.classList.remove('input-error');
      }
    }
  }

const register = async (e) => {
    e.preventDefault();
    
    if(passwordErrors.passwordCheck){
      alert("비밀번호 입력을 확인해주세요");
      return
    } else {
        const fields = ["email", "password", "name", "cellphone", "role"];
        const formElements = e.target.elements;

        const formValues = fields
        .map((field) => ({
          [field]: formElements.namedItem(field).value
        }))
        .reduce((current, next) => ({ ...current, ...next }));
        
        // 전화번호 formatting 해제
        const replacePhoneNumber = formValues["cellphone"].replaceAll('-','');
        const updatedFormValues = { ...formValues, cellphone: replacePhoneNumber };

        let registerRequest;

        try {
          registerRequest = await axios.post(
            `/register`,
            {
              ...updatedFormValues
            },
            { baseURL : process.env.REACT_APP_SERVER_URL },
            {
              withCredentials: true
            }
          );
        } catch ({ response }) {
          registerRequest = response;
        }
        //console.log(registerRequest);

        const { data: registerRequestData } = registerRequest;

        const messages = registerRequestData.messages;

        if ( registerRequestData.success ) {

          // 성공 메세지 표출
          if (messages && messages.success) {
            alert(messages.success);
          }

          // 성공 후 로그인 페이지로 이동
          return navigate("/Login");

        } else {
          // 실패 메세지 표출
          if (messages && messages.errors) {
            /*
            //메세지 alert을 위한 문자 만들기
            const errors = messages.errors;

            const getErrorMessages = (errors) => {
              const errorMessages = Object.values(errors);
              return errorMessages.join('\n');
            };
        
            const errorMessage = getErrorMessages(errors);
            */

            setErrorMessage({ message: messages.errors });

            // 오류 필드에 포커스 설정
            if(messages.errors && messages.errors.name) {
              setFullNameFocus(true);
            }

            if(messages.errors && messages.errors.cellphone) {
              setCellPhoneFocus(true);
            }

            if(messages.errors && messages.errors.email) {
              setEmailFocus(true);
            }

            if(messages.errors && messages.errors.password) {
              setPasswordFocus(true);
            }
          }

          if (messages && messages.databaseError) {
            setErrorMessage({ message: messages.databaseError });
            setEmailFocus(true);
          }
          
        }
    }
  };

  const goBack = (e) => {
    e.preventDefault();
    navigate(-1);
  }

  useEffect(() => {
    document.documentElement.addEventListener("mousemove", followCursor);
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.documentElement.removeEventListener("mousemove", followCursor);
    };
  }, []);

  const followCursor = (event) => {
    let posX = event.clientX - window.innerWidth / 2;
    let posY = event.clientY - window.innerWidth / 6;
    setSquares1to6(
      "perspective(500px) rotateY(" +
        posX * 0.05 +
        "deg) rotateX(" +
        posY * -0.05 +
        "deg)"
    );
    setSquares7and8(
      "perspective(500px) rotateY(" +
        posX * 0.02 +
        "deg) rotateX(" +
        posY * -0.02 +
        "deg)"
    );
  };

  return (
    <>
    <Navbar/>
      <div className="wrapper register-page">
        <div className="page-header">
          <div className="page-header-image" />
          <div className="content" id="registerContent">
            <Container>
              <Row>
                <Col className="login-card">
                  <Card className="card-register">
                    <CardHeader>
                      <CardTitle tag="h4">Register</CardTitle>
                    </CardHeader>
                      <Form className="form" onSubmit={register}>
                        <CardBody>
                          <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faUser} />
                              </InputGroupText>
                              <Input
                                placeholder="Name"
                                type="text"
                                name="name"
                                value={formData.name}
                                required
                                onChange= {handleInputChange}
                                onFocus={(e) => setFullNameFocus(true)}
                                onBlur={(e) => setFullNameFocus(false)}
                                className={classnames({
                                  "input-focus": fullNameFocus,
                                })}
                              />
                            </InputGroup>

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.name}</div>
                            )}

                            <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faMobileScreen} />
                              </InputGroupText>
                              <Input
                                placeholder="Phone(선택입력사항)"
                                type="text"
                                name="cellphone"
                                value={formData.cellphone}
                                onChange= {handleInputChange}
                                onFocus={(e) => setCellPhoneFocus(true)}
                                onBlur={(e) => setCellPhoneFocus(false)}
                                
                                className={classnames({
                                  "input-focus": cellPhoneFocus,
                                })}
                              />
                            </InputGroup>

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.cellphone}</div>
                            )}

                            <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faEnvelope} />
                              </InputGroupText>
                              <Input
                                placeholder="Email(ID)"
                                type="email"
                                name="email"
                                value={formData.email}
                                required
                                onChange= {handleInputChange}
                                onFocus={(e) => setEmailFocus(true)}
                                onBlur={(e) => setEmailFocus(false)}
                                
                                className={classnames({
                                  "input-focus": emailFocus,
                                })}
                              />
                            </InputGroup>

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.email}</div>
                            )}

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.code}</div>
                            )}

                            <InputGroup>
                              <InputGroupText>
                                <FontAwesomeIcon icon={faKey} />
                              </InputGroupText>
                              <Input
                                placeholder="Password"
                                type="password"
                                name="password"
                                value={formData.password}
                                required
                                onChange= {handleInputChange}
                                onKeyUp= {validatePassword}
                                onBlur= {validatePassword} 
                                
                                className={classnames({
                                  "input-focus": passwordFocus,
                                })}
                              />
                            </InputGroup>
                            
                            <InputGroup id="passwordCheckBorder">
                              <InputGroupText id="passwordCheckIcon" className="checkNone">
                                <FontAwesomeIcon icon={faCheck} />
                              </InputGroupText>
                              <Input
                                placeholder="Password Check"
                                type="password"
                                id="passwordCheck"
                                name="passwordCheck"
                                required
                                onChange= {handleInputChange}
                                onKeyUp= {validatePassword}
                                onBlur={validatePassword}
                              />
                            </InputGroup>
                            {passwordErrors.passwordCheck && (
                              <div className="errorMessage" style={{ color: 'red' }}>{passwordErrors.passwordCheck}</div>
                            )}

                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red', marginBottom:'10px' }}>{errorMessage.message.password}</div>
                            )}

                            {/* 
                            {errorMessage.message && (
                              <div className="errorMessage" style={{ color: 'red' }}>{errorMessage.message}</div>
                            )} */}
                            
                            <InputGroup>
                              <Input
                                type="hidden"
                                name="role"
                                value="user"
                                onChange= {handleInputChange}
                              />
                            </InputGroup>

                            <FormGroup check className="text-left">
                              <Label check>
                                <Input type="checkbox" required/>
                                <span className="form-check-sign"/>
                                <span className="form-check-icon"><FontAwesomeIcon icon={faCheck} /></span>
                                <a href="/privacy" target="_blank">
                                  개인정보처리방침
                                </a>
                                을 확인하였으며, 이에 동의합니다
                              </Label>
                            </FormGroup>
                        </CardBody>
                        <CardFooter>
                          <Button type="button" className="itsBtnGray" size="md" onClick={goBack}>
                            이전
                          </Button>
                          <Button type="submit" className=" itsBtnDefault" size="md">
                            회원가입
                          </Button>
                        </CardFooter>
                      </Form>
                  </Card>
                </Col>
              </Row>
              <div
                className="square square-7"
                id="square7"
                style={{ transform: squares7and8 }}
              />
              <div
                className="square square-8"
                id="square8"
                style={{ transform: squares7and8 }}
              />
              <div
                className="square square-1"
                id="square1"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-2"
                id="square2"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-3"
                id="square3"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-4"
                id="square4"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-5"
                id="square5"
                style={{ transform: squares1to6 }}
              />
              <div
                className="square square-6"
                id="square6"
                style={{ transform: squares1to6 }}
              />
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}